import { Meta } from "@layouts/page";
import Head from "next/head";

const LitePage = ({
  title,
  nofollow,
  noindex,
  canonical,
  children,
}: Pick<Meta, "title" | "nofollow" | "noindex" | "canonical"> & {
  children: React.ReactNode;
}) => {
  return (
    <>
      <Head>
        {title ? <title>{title}</title> : null}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        {canonical ? <link rel="canonical" href={canonical} /> : null}
        {nofollow && <meta name="robots" content="nofollow" />}
        {noindex && <meta name="robots" content="noindex" />}
      </Head>
      {children}
    </>
  );
};

export default LitePage;
